import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { LoginService } from '@app/core/services/login/login.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ResetPassword } from '@app/shared/validators/reset-passsword';
import { environment } from "environments/environment";

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {

  forgotemail !: string;
  forgotEmailToken: any;
  resetPassForm: FormGroup;
  redirectTo: string;

  constructor(private formBuilder: FormBuilder, private router: Router, private loaderService: LoaderService,
    private notification: NotificationService, private loginService: LoginService, private activatedRoute: ActivatedRoute) {
    this.resetPassForm = formBuilder.group({
      Password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      ConfirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    }, {
      validator: ResetPassword.ResetPassword
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.resetPassForm.controls; }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.forgotemail = params['eid'];
      this.forgotEmailToken = params['tkn'];
      this.redirectTo = params['rf'];
    });
  }

  onSubmit(form: FormGroup) {
    this.loaderService.show();

    this.loginService.resetPassword(this.forgotemail, encodeURIComponent(this.forgotEmailToken), encodeURIComponent(form.value.Password))
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.notification.success(res.Message, 'Password reset');

          if (this.redirectTo.toLowerCase() == "merchloop")           
            this.notification.info('Redirecting back to login screen', 'Login');
          else if (this.redirectTo.toLowerCase() == "shopify"){
            this.notification.infoAlways('Please login at Shopify', 'Login');
            setTimeout(() => {
              window.close();
            }, 3000);
          }
          
          this.router.navigate(['']);

          this.loaderService.hide();

        } else if (res.StatusCode === 500) {
          this.notification.error(res.Message, 'Password reset');
        } else {
          this.notification.error('An error occured', 'Error');
        }
        this.loaderService.hide();
      }, (err: any) => {
        this.notification.error('An error occured', 'Error');
        this.loaderService.hide();
      });
  }
}
